module.exports = __webpack_public_path__ + "static/img/li_4.9ba7ca4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_4.jpeg
// module id = ynZE
// module chunks = 6